function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
export function TableFixedColumn(props) {
  var _usePrefixCls;

  var width = props.width,
      height = props.height,
      position = props.position,
      cover = props.cover,
      children = props.children;
  var cls = usePrefixCls('table-column-fixed', (_usePrefixCls = {}, _defineProperty(_usePrefixCls, position, true), _defineProperty(_usePrefixCls, "cover", cover), _usePrefixCls));
  return React.createElement("div", {
    className: cls,
    style: {
      width: "".concat(width, "px"),
      height: "".concat(height, "px")
    }
  }, children);
}